import { render, staticRenderFns } from "./playlist-suggestions.vue?vue&type=template&id=0a2cffb3&scoped=true&"
import script from "./playlist-suggestions.vue?vue&type=script&lang=js&"
export * from "./playlist-suggestions.vue?vue&type=script&lang=js&"
import style0 from "./playlist-suggestions.vue?vue&type=style&index=0&id=0a2cffb3&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2cffb3",
  null
  
)

export default component.exports